import React from "react";
import { Button } from "@material-ui/core";
import WithAuth from "../containers/WithAuth";
import { inject, observer } from "mobx-react";

class CustomClipCreatedToast extends React.Component {
  render() {
    const { routerStore } = this.props;
    return (
      <div>
        Created custom clip!
        <Button
          variant="text"
          color="primary"
          onClick={() =>
            routerStore.history.push("/clips?selectedTab=MY_CUSTOM_CLIPS")
          }
        >
          My Clips
        </Button>
      </div>
    );
  }
}

export default WithAuth(
  inject("routerStore")(observer(CustomClipCreatedToast))
);



// WEBPACK FOOTER //
// ./src/components/CustomClipCreatedToast.js